import { createBrowserRouter, Navigate, type RouteObject } from "react-router-dom";
import { AppLayout } from "./layouts/AppLayout";
import { ClientLayout } from "./layouts/ClientLayout";
import { ProtectedRoute } from "./components/ProtectedRoute";
import SummaryPage from "./pages/admin/SummaryPage";
import AppsPage from "./pages/admin/AppsPage";
import AppPage from "./pages/admin/AppPage";
import UsersPage from "./pages/admin/UsersPage";
import GroupsPage from "./pages/admin/GroupsPage";
import LocalsPage from "./pages/admin/LocalsPage";
import AdminLogPage from "./pages/admin/LogPage";
import KeysPage from "./pages/admin/KeysPage";
import AdminSettingsPage from "./pages/admin/SettingsPage";
import SecurityPage from "./pages/admin/SecurityPage";
import AnalyticsPage from "./pages/admin/AnalyticsPage";
import DocsPage from "./pages/admin/DocsPage";
import LocalStatusPage from "./pages/local/StatusPage";
import LocalSyncPage from "./pages/local/SyncPage";
import LocalLogPage from "./pages/local/LogPage";
import LocalCachePage from "./pages/local/CachePage";
import LocalNetPage from "./pages/local/NetPage";
import LocalServicesPage from "./pages/local/ServicesPage";
import MyAppsPage from "./pages/dev/MyAppsPage";
import UploadPage from "./pages/dev/UploadPage";
import StatsPage from "./pages/dev/StatsPage";
import TokensPage from "./pages/dev/TokensPage";
import DevSettingsPage from "./pages/dev/SettingsPage";
import ClientLogin from "./pages/client/LoginPage";
import ClientCatalog from "./pages/client/CatalogPage";
import ClientAppPage from "./pages/client/AppPage";
import ClientUpdates from "./pages/client/UpdatesPage";
import ClientInstalled from "./pages/client/InstalledPage";
import ClientBlock from "./pages/client/BlockPage";
import ClientLocation from "./pages/client/LocationPage";
import LoginPage from "./pages/LoginPage";

const routes: RouteObject[] = [
  // Логин — без общего layout, без auth-guard
  { path: "/login", element: <LoginPage /> },

  // Admin / Local / Dev — общий layout с TopBar+Sidebar за auth-guard'ом
  {
    element: <ProtectedRoute />,
    children: [
      {
        path: "/",
        element: <AppLayout />,
        children: [
          { index: true, element: <Navigate to="/admin" replace /> },

          // Глобальный администратор
          { path: "admin",              element: <SummaryPage />, handle: { title: "Сводка" } },
          { path: "admin/apps",         element: <AppsPage />,    handle: { title: "Приложения" } },
          { path: "admin/apps/:pkg",    element: <AppPage />,     handle: { title: (p: Record<string, string | undefined>) => p.pkg ?? "Карточка" } },
          { path: "admin/users",        element: <UsersPage />,   handle: { title: "Пользователи" } },
          { path: "admin/groups",       element: <GroupsPage />,  handle: { title: "Группы" } },
          { path: "admin/locals",       element: <LocalsPage />,  handle: { title: "Локальные серверы" } },
          { path: "admin/log",          element: <AdminLogPage />,      handle: { title: "Журнал" } },
          { path: "admin/keys",         element: <KeysPage />,          handle: { title: "Ключи подписи" } },
          { path: "admin/settings",     element: <AdminSettingsPage />, handle: { title: "Настройки" } },
          { path: "admin/security",     element: <SecurityPage />,      handle: { title: "Безопасность" } },
          { path: "admin/analytics",    element: <AnalyticsPage />,     handle: { title: "Аналитика" } },
          { path: "admin/docs",         element: <DocsPage />,          handle: { title: "Документация" } },

          // Локальный администратор
          { path: "local",              element: <LocalStatusPage />, handle: { title: "Состояние" } },
          { path: "local/sync",         element: <LocalSyncPage />,   handle: { title: "Синхронизация" } },
          { path: "local/cache",        element: <LocalCachePage />,    handle: { title: "Кэш" } },
          { path: "local/log",          element: <LocalLogPage />,      handle: { title: "Журнал" } },
          { path: "local/net",          element: <LocalNetPage />,      handle: { title: "Сеть" } },
          { path: "local/services",     element: <LocalServicesPage />, handle: { title: "Сервисы" } },

          // Разработчик
          { path: "dev",                element: <MyAppsPage />, handle: { title: "Мои приложения" } },
          { path: "dev/upload",         element: <UploadPage />, handle: { title: "Загрузка APK" } },
          { path: "dev/apps/:pkg/upload", element: <UploadPage />, handle: { title: (p: Record<string, string | undefined>) => p.pkg ?? "Новая версия" } },
          { path: "dev/stats",          element: <StatsPage />,  handle: { title: "Статистика" } },
          { path: "dev/tokens",         element: <TokensPage />,      handle: { title: "Токены API" } },
          { path: "dev/settings",       element: <DevSettingsPage />, handle: { title: "Настройки" } },
        ],
      },
    ],
  },

  // Android-клиент — собственный mobile layout, без auth-guard (прототип)
  {
    path: "/client",
    element: <ClientLayout />,
    children: [
      { index: true,            element: <ClientCatalog /> },
      { path: "login",          element: <ClientLogin /> },
      { path: "app/:pkg",       element: <ClientAppPage /> },
      { path: "updates",        element: <ClientUpdates /> },
      { path: "installed",      element: <ClientInstalled /> },
      { path: "block",          element: <ClientBlock /> },
      { path: "location",       element: <ClientLocation /> },
    ],
  },

  { path: "*", element: <Navigate to="/admin" replace /> },
];

export const router = createBrowserRouter(routes);
